import React, { useEffect, useState } from "react";
import '../css/UnitList.css';
import { useNavigate } from 'react-router-dom';

const ExpenseList = () => {
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [deleteModal, setDeleteModal] = useState({ show: false, expense: null });
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchExpenses = async () => {
      setLoading(true);
      setError("");
      try {
        const API_URL = process.env.REACT_APP_API_URL || "";
        const response = await fetch(`${API_URL}list-expense.php`, { method: "GET" });
        if (!response.ok) throw new Error("Failed to fetch expenses");
        const data = await response.json();
        setExpenses(Array.isArray(data.data) ? data.data : []);
      } catch (err) {
        setError(err.message || "Error fetching expenses");
      } finally {
        setLoading(false);
      }
    };
    fetchExpenses();
  }, []);

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: '', type: '' });
    }, 3000);
  };

  const handleDeleteClick = (expense) => {
    setDeleteModal({ show: true, expense });
  };

  const handleDeleteConfirm = async () => {
    if (!deleteModal.expense) return;
    try {
      const API_URL = process.env.REACT_APP_API_URL || "";
      const response = await fetch(`${API_URL}delete-expense.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: deleteModal.expense.id })
      });
      const data = await response.json();
      if (data.status) {
        setExpenses(expenses.filter(exp => exp.id !== deleteModal.expense.id));
        showToast('Expense deleted successfully', 'success');
      } else {
        showToast(data.message || 'Failed to delete expense', 'error');
      }
    } catch (error) {
      showToast('Error deleting expense', 'error');
    }
    setDeleteModal({ show: false, expense: null });
  };

  const handleDeleteCancel = () => {
    setDeleteModal({ show: false, expense: null });
  };

  const handleEdit = (expense) => {
    navigate(`/edit-expense/${expense.id}`, { state: { expense } });
  };

  return (
    <div className="unit-list-content">
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className="header-content">
          <h1>Expense List</h1>
          <p>View and manage all expenses</p>
        </div>
        <button 
          className="btn btn-primary" 
          style={{ minWidth: 120, height: 40, fontWeight: 'bold', fontSize: 16 }}
          onClick={() => window.location.href = '/add-expense'}
        >
          + Add Expense
        </button>
      </div>
      <div className="unit-list-table-container">
        {loading ? (
          <p style={{ padding: '1rem' }}>Loading...</p>
        ) : error ? (
          <p style={{ color: "red", padding: '1rem' }}>{error}</p>
        ) : expenses.length === 0 ? (
          <p style={{ padding: '1rem' }}>No expenses found.</p>
        ) : (
          <>
            <table className="unit-list-table">
              <thead>
                <tr>
                  <th>Item Name</th>
                  <th>Description</th>
                  <th>Amount</th>
                  <th>Purchase Date</th>
                  <th>Payment Type</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {expenses.map((exp, idx) => (
                  <tr key={idx}>
                    <td>{exp.item_name}</td>
                    <td>{exp.description}</td>
                    <td>{exp.amount}</td>
                    <td>{exp.purchase_date}</td>
                    <td>{exp.payment_type}</td>
                    <td>
                      <div className="action-buttons">
                        <button className="action-btn edit" onClick={() => handleEdit(exp)}>Edit</button>
                        <button className="action-btn delete" onClick={() => handleDeleteClick(exp)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table-footer">
              <div className="results-info">
                Showing {expenses.length} expense{expenses.length !== 1 ? 's' : ''}
              </div>
            </div>
          </>
        )}
      </div>
      {/* Delete Confirmation Modal */}
      {deleteModal.show && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Delete Expense</h3>
            </div>
            <div className="modal-body">
              <p>
                Are you sure you want to delete the expense <strong>"{deleteModal.expense?.item_name}"</strong>?
              </p>
              <p>This action cannot be undone.</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={handleDeleteCancel}>
                No, Cancel
              </button>
              <button className="btn btn-danger" onClick={handleDeleteConfirm}>
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Toast Notification */}
      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          <div className="toast-content">
            <span className="toast-message">{toast.message}</span>
            <button 
              className="toast-close" 
              onClick={() => setToast({ show: false, message: '', type: '' })}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpenseList; 